<template>
  <div v-if="shiftplan.length > 1">
    <v-card>
      <v-card-title>{{ shiftplan[0].name }}</v-card-title>
      <v-card-text>
        <v-btn
          class="ma-2"
          shaped
          v-if="rawdata"
          @click="modifyServerData"
          color="primary"
          >Aktivieren
          <v-icon right>mdi-send</v-icon>
        </v-btn>

        <div>
          <div v-for="shift in shiftplan[0].shifts" :key="shift.name">
            <v-card-title>{{ shift.name }}</v-card-title>

            <v-card-text v-for="wp in shift.workplaces" :key="wp.name">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-if="wp.name != 'none'">{{
                      wp.name
                    }}</v-list-item-title>
                    <ui v-for="worker in wp.worker" :key="worker.name">
                      <li>
                        {{ worker.name }}
                      </li>
                      <br />
                    </ui>
                    <br />
                    <v-divider></v-divider>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import configuration from "../../configuration.json";

export default {
  props: ["data", "searchterm", "file"],
  data() {
    return {
      shiftplan: [],
      rawdata: undefined,
    };
  },
  mounted() {
    this.rawdata = JSON.parse(this.data);
    
    // map Shiftplan if rawdata is empty
    if (
      this.rawdata != undefined &&
      this.rawdata.data != undefined &&
      this.rawdata.data.length != undefined 
    ) {
      for(let i=0;i<this.rawdata.data.length;i++)
      {
        try{
            // eslint-disable-next-line no-console
          console.log(`${this.rawdata.data.length}--${i}--${this.rawdata.sheets[i]}`);
          this.mapShiftPlan(i, this.rawdata.sheets[i]);
        }
        catch(e)
        {
          // eslint-disable-next-line no-console
          console.log(`Error: ${e}`);
        }
       
      }
      
      // load data if endpoint is empty
    }
  },
  methods: {
    // map shiftplan
    mapShiftPlan: function (datarecord, targetDate) {
      // generate shiftplan variable by rawdata
      let tempStr = JSON.stringify(this.rawdata.data[datarecord])
        .replace(/__vue_devtool_undefined__/g, "")
        .replace(/undefined/g, '""')
        .replace(/null/g, '""');
      let rawdata = JSON.parse(tempStr);
      let shiftplan = {
        month: targetDate.substring(0,2),
        year: "20" + targetDate.substring(2,4),
        name: rawdata[1][16],
        shifts: [],
      };

      let maxDays = new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1 + datarecord,
        0
      ).getDate();

      // push values to shiftplan array
      this.shiftplan.push(shiftplan);

      //The parsing is using a current shift and a current workplace
      let currentShiftGroup = undefined;
      let currentWorkplace = undefined;

      //iterate over all rows of the sheet. We start at line 3, because we don't care about the generic headers
      for (let i = 3; rawdata.length && rawdata[i] != null; i++) {
        let record = rawdata[i];

        //Find shift group (e.g. "A","B") and store the planned shift time of that shift
        if (record[1] == "Schicht") {
          //Set the shift group name
          currentShiftGroup = {
            name: record[2],
            plan: [],
            capa: [],
            workplaces: [],
          };

          // eslint-disable-next-line no-console
          console.log("Plan" + JSON.stringify(currentShiftGroup));

          // iterate over records
          for (let j = 3; j < maxDays + 3; j++) {
            let timeValue = "g";

            if (record[j] != undefined && record[j] != null) {
              switch (record[j].toLowerCase()) {
                case "fr":
                  timeValue = "F";
                  break;
                case "sp":
                  timeValue = "S";
                  break;
                case "na":
                  timeValue = "N";
                  break;
                case "no":
                  timeValue = "R";
                  break;
                case "":
                  timeValue = "g";
                  break;
              }
            }

            currentShiftGroup.plan.push(timeValue);
            currentShiftGroup.capa.push(1);
          }
          // push current shiftgroup to shifts in shiftplan array
          shiftplan.shifts.push(currentShiftGroup);

          let wpName = "none";
          // set current workplace
          currentWorkplace = {
            name: wpName,
            worker: [],
          };

          //backup the index of each workplace. It happens, that a user down the line has an already created workplace
          if (currentShiftGroup[wpName] == undefined) {
            currentShiftGroup[wpName] = currentShiftGroup.workplaces.length;
          }
          // push current workplace to shiftgroup workplaces array
          currentShiftGroup.workplaces.push(currentWorkplace);
        }

        let recordZero = isNaN(parseFloat(record[0]));
        let recordOne = Number.isInteger(record[1]);

        // check if records are empty
        if (!recordZero && recordOne && record[2] != "") {
          // get worker record
          let worker = {
            employeeId: record[1],
            name: record[2],
            notes: [],
            altShifts: [],
          };

          // eslint-disable-next-line no-console
          console.log("Plan" + JSON.stringify(worker));

          // iterate over records
        for (let j = 3; j < maxDays + 3; j++) {
          let timeValue = "";
          let altShiftLabel = "";

          if (record[j] != undefined && record[j] != null) {
            if (record[j].toLowerCase().startsWith("fr")) {
              timeValue = "F";
            } else if (record[j].toLowerCase().startsWith("sp")) {
              timeValue = "S";
            } else if (record[j].toLowerCase().startsWith("na")) {
              timeValue = "N";
            } else if (record[j].toLowerCase().startsWith("no")) {
              timeValue = "R";
            } else if(
              record[j].toLowerCase().startsWith("ku") || 
              record[j].toLowerCase().startsWith("tu") ||
              record[j].toLowerCase().startsWith("gz") ||
              record[j].toLowerCase().startsWith("tz") ||
              record[j].toLowerCase().startsWith("kr") ||
              record[j].toLowerCase().startsWith("kk") ||
              record[j].toLowerCase().startsWith("uu") ||
              record[j].toLowerCase().startsWith("az")){
                timeValue = record[j].toUpperCase();
            }
            }

            if (record[j] != undefined && record[j].length == 1) {
              timeValue = record[j].toUpperCase();
            } else if (record[j] != undefined && record[j].length == 2 && timeValue == "") {
              timeValue = "AW";
            } else if (record[j] != undefined && record[j].length > 3) {
              altShiftLabel = record[j].substring(3);
            }

            worker.notes.push(timeValue);
            worker.altShifts.push(altShiftLabel);
          
          }
          // if current shiftgroup name equals workplaces entry, push worker to current workplace array
          if (
            currentShiftGroup[currentWorkplace.name] ==
            currentShiftGroup.workplaces.length - 1
          ) {
            currentWorkplace.worker.push(worker);
          } else {
            let currentShiftWorkers =
              currentShiftGroup.workplaces[
                currentShiftGroup[currentWorkplace.name]
              ];
            currentShiftWorkers.worker.push(worker);
          }
        }
      }

      // eslint-disable-next-line no-console
      console.log(JSON.stringify(this.shiftplan));
    },
    // code for search
    containsSearch: function (line) {
      let returnValue =
        this.searchterm == undefined || this.searchterm.length < 3;
      let self = this;
      if (!returnValue) {
        line.workstation.forEach(function (ws) {
          ws.person.forEach(function (person) {
            if (
              person.name.toLowerCase().includes(self.searchterm.toLowerCase())
            ) {
              returnValue = true;
            }
          });
        });
      }
      return returnValue;
    },
    // code for search in workstation
    workstationSearch: function (ws) {
      let returnValue =
        this.searchterm == undefined || this.searchterm.length < 3;
      let self = this;
      if (!returnValue) {
        ws.person.forEach(function (person) {
          if (
            person.name.toLowerCase().includes(self.searchterm.toLowerCase())
          ) {
            returnValue = true;
          }
        });
      }
      return returnValue;
    },
    // modify server data
    modifyServerData: async function () {
      let url = `${configuration.fileUrl}/wfm/${this.file}.json`;

      let config = {
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": "application/json",
        },
      };

      try {
        let response = await axios.put(url, JSON.stringify(this.shiftplan), config);
        
        if(response.status == 201)
        {
          this.$emit("uploaded");
        }
        else{
          alert("Fehler beim Upload");

          // eslint-disable-next-line no-console
          console.log(JSON.stringify(response))
        }
        
      } catch (error) {
        alert(
          "Error! Upload fehlgeschlagen. Verbindung zum Server nicht möglich."
        );
      }
    },
  },
};
</script>
